/**
 * Source identifier for group class registration API calls.
 * Used to indicate the registration was initiated from the recommended groups modal.
 */
enum GroupClassRegistrationSource {
  RecommendedGroupsModal = "RECOMMENDED_GROUPS_MODAL",
}

export { GroupClassRegistrationSource };
